import React from "react";
import { Link } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

// core components
import componentStyles from "assets/theme/components/cards/dashboard/card-dashboard-generic.js";
import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import { useTheme } from "@material-ui/core/styles";
import TableStateChip from "components/Cards/Tables/TableStateChip";
import CardTableContainer from "components/Cards/Tables/CardTableContainer";
import { TABLE_STATE_CHIP_COLOR } from "utils/const";
import { CONTRACT_APPROVAL_STATUS } from "utils/const";
import { ConditionGuard } from "guards/ConditionGuard";
import { useQuery } from "@tanstack/react-query";
import { getFilteredForDashboard } from "crud/contractApproval.crud";
import TableBackdrop from "components/Backdrops/TableBackdrop/TableBackdrop";

const useStyles = makeStyles(componentStyles);
const useStylesGeneric = makeStyles(componentStylesGeneric);

const tableHead = ["Data de Submissão", "Nº de Pedido", "Nº de contratos", "Tipo de Contrato", "Estado", ""];

function CardContractApproval() {
  const classes = { ...useStylesGeneric(), ...useStyles() };
  const theme = useTheme();

  const mapOpportunityStateToTableChipColors = (stateKey) => {
    switch (stateKey) {
      case CONTRACT_APPROVAL_STATUS.CONCLUDED:
        return TABLE_STATE_CHIP_COLOR.GREEN;
      case CONTRACT_APPROVAL_STATUS.CANCELED:
        return TABLE_STATE_CHIP_COLOR.RED;
      case CONTRACT_APPROVAL_STATUS.AWAITING_PAYMENT:
      case CONTRACT_APPROVAL_STATUS.AWAITING_RECTIFICATION:
      case CONTRACT_APPROVAL_STATUS.AWAITING_VALIDATION:
      case CONTRACT_APPROVAL_STATUS.AWAITING_PAYMENT_DATA:
        return TABLE_STATE_CHIP_COLOR.LIGHT_ORANGE;
      case CONTRACT_APPROVAL_STATUS.CREATED:
        return TABLE_STATE_CHIP_COLOR.YELLOW;
      case CONTRACT_APPROVAL_STATUS.SUBMITTED:
        return TABLE_STATE_CHIP_COLOR.BLUE;
      default:
        return <></>;
    }
  };

  const { data, isLoading } = useQuery(["getFilteredForDashboard"], () => getFilteredForDashboard());

  return (
    <CardTableContainer
      title={"Pedidos de Homologação de Contrato em Curso"}
      count={data?.totalCount}
      viewMoreLink={`/admin/contract-approval/list`}
    >
      <TableContainer>
        <ConditionGuard condition={!isLoading} fallback={<TableBackdrop open />}>
          <Box component={Table} alignItems="center" marginBottom="0!important">
            <TableHead>
              <TableRow>
                {tableHead.map((prop, key) => (
                  <TableCell
                    key={key}
                    classes={{
                      root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                    }}
                  >
                    {prop}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.data?.map((prop, key) => (
                <TableRow key={key}>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.requestDate}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.requestNumber}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.numberOfContracts}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.contractTypeDescriptions}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                      <TableStateChip
                        state={mapOpportunityStateToTableChipColors(prop.statusKeyValue)}
                        message={prop.statusDescription}
                      />
                    </Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Tooltip title="Detalhes">
                      <IconButton
                        aria-label="details"
                        component={Link}
                        to={`/admin/contract-approval/details/${prop.requestNumber}`}
                      >
                        <Box
                          component={ArrowForwardIosIcon}
                          width="9px!important"
                          height="9px!important"
                          color={theme.palette.primary.main}
                        />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Box>
        </ConditionGuard>
      </TableContainer>
    </CardTableContainer>
  );
}

export default CardContractApproval;
